import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { API_URL } from "../../../config";

const AddSiteModal = ({ isOpen, toggle, onCreated }) => {
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const distributorId = localStorage.getItem("user_id");
  const token = localStorage.getItem("accessToken");

  const handleClose = () => {
    if (saving) return;
    setName("");
    setError("");
    toggle();
  };

  const handleSubmit = async () => {
    if (!name.trim()) {
      setError("Site name is required.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/distributor/site/${distributorId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({ name: name.trim() }),
      });
      const data = await res.json();
      if (data.status && data.data) {
        onCreated(data.data);
        setName("");
        toggle();
      } else {
        setError(data.message || "Failed to create site.");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered>
      <ModalHeader toggle={handleClose} style={{ background: "rgb(77, 0, 77)", color: "white" }}>
        <i className="fa fa-map-marker" style={{ marginRight: "8px" }}></i>
        Add Site
      </ModalHeader>
      <ModalBody>
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div>
            <label
              style={{
                fontWeight: "600",
                marginBottom: "6px",
                display: "block",
              }}
            >
              <i
                className="fa fa-map-marker"
                style={{ color: "rgb(77, 0, 77)", marginRight: "6px" }}
              ></i>
              Site Name *
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Main Warehouse"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                background: "white",
              }}
            />
          </div>

          {error && (
            <div
              style={{
                color: "red",
                fontSize: "13px",
                background: "#fff0f0",
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #fca5a5",
              }}
            >
              {error}
            </div>
          )}
        </div>
      </ModalBody>
      <ModalBody
        style={{
          borderTop: "1px solid #dee2e6",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          padding: "12px 16px",
        }}
      >
        <button
          className="btn"
          style={{ background: "#ccc", color: "#333" }}
          onClick={handleClose}
          disabled={saving}
        >
          Cancel
        </button>
        <button
          className="btn"
          style={{ background: "rgb(77, 0, 77)", color: "white" }}
          onClick={handleSubmit}
          disabled={saving}
        >
          {saving ? "Saving..." : "Add Site"}
        </button>
      </ModalBody>
    </Modal>
  );
};

export default AddSiteModal;
